// extracted by mini-css-extract-plugin
export default {"button":"Buttons__button--3AA","demo":"Buttons__demo--3YV","play":"Buttons__play--3_v"};